module.exports = __webpack_public_path__ + "af0415adafdfd15136263ce84e6fb911.svg";